import CONSTANTS from '@/constants/constants';

const barcodeList = Object.values(CONSTANTS.barcodeTypes);
export const findBarcodeType = barcode => (barcodeList
  .find(({ validate }) => validate(barcode))
);
